import { push, RouterState } from "connected-react-router";
import { put, select, takeEvery } from "redux-saga/effects";
import { AUTH_LOGOUT_REQUEST } from "../../../auth";

/**
 * Paths that are part of the login round trip itself.  Sending the user back to one of
 * these after they log in would either loop or drop them somewhere meaningless.
 */
const AUTH_PATHS: string[] = ["/authorize", "/join", "/login", "/onboarding", "/sign-in-link", "/sign-up", "/signup"];

export function* logout() {
    const router: RouterState = yield select((state: { router: RouterState }) => state.router);

    const pathname: string = router?.location?.pathname;
    const search: string = router?.location?.search;

    // Carry the path the user asked for through the login round trip.  Without this a deep
    // link, say /admin/leads/<leadId>, is lost the moment anything logs the user out and
    // they come back to the default page instead of the one they opened.
    if (pathname && !AUTH_PATHS.some(authPath => pathname.startsWith(authPath))) {
        yield put(
            push({
                pathname: "/login",
                state: {
                    from: {
                        pathname,
                        search
                    }
                }
            })
        );
        return;
    }

    yield put(push("/login"));
}

export function* watchLogout() {
    yield takeEvery(AUTH_LOGOUT_REQUEST, logout);
}
